if (!customElements.get("scrolling-elements")) {
  customElements.define(
    "scrolling-elements",
    class ScrollingElements extends HTMLElement {
      constructor() {
        super();
      }

    connectedCallback() {
      if (this.offsetParent === null) return;

      const container = this.querySelector(".scrolling-elements-wrap");
      const group = container.querySelector(".scrolling-elements-group");

      if (!group) return;

      const groupWidth = group.offsetWidth;

      // Total width should be at least 2x viewport
      while (container.scrollWidth < window.innerWidth * 2) {
        container.appendChild(group.cloneNode(true));
      }
    }
    },
  );
}
